import "./ViewProfile.scss";
import CloseIcon from "@mui/icons-material/Close";
import CreateIcon from "@mui/icons-material/Create";
import { Button } from "@mui/material";
import { getUserData, setUser } from "../../../actions/authActions";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import SessionsListView from "../../Auth/SessionsListView";

const ViewProfile = (props: any) => {
  const { t, i18n } = useTranslation();
  const { openEdit, onClose } = props;
  const [userData, setUserData] = useState<any>({});
  const userId = JSON.parse(localStorage.getItem("user") || "").owner;
  //useSelector((state:any)=> state.auth.userId);
  const dispatch = useDispatch();

  const getUserInfo = async () => {
    const userInfo = (await getUserData()).data;
    console.log("User : ", userInfo);
    const userInfoData = {
      firstName: userInfo.firstname,
      lastName: userInfo.lastname,
      displayName: userInfo.displayName,
      profileImageUrl: userInfo.profileImageUrl,
      email: userInfo.email,
      mobile: userInfo.mobile,
      dialCode: userInfo.dialCode,
      address: userInfo.address,
    };
    setUserData(userInfoData);
    dispatch(setUser(userInfoData));
    localStorage.setItem("user", JSON.stringify(userInfo));
  };

  useEffect(() => {
    getUserInfo();
  }, []);

  return (
    <div className="pw-myaccount">
      <div className="pw-profile-header">
        <div className="pw-account">{t("My account")}</div>
        <Button onClick={openEdit} className="pw-editbox">
          <CreateIcon className="pw-edit-icon" />
          <div className="pw-edit">{t("Edit")}</div>
        </Button>
        <Button onClick={onClose} id="pw-e2e-profilecloseicon">
          <CloseIcon className="pw-closeicon" />
        </Button>
      </div>

      <div className="pw-contactinfo">
        <img
          src={
            userData.profileImageUrl
              ? userData.profileImageUrl
              : "assets/images/AvatarEmpty.png"
          }
          alt=" "
          className="pw-circularimage"
        />
        <div className="pw-name">{userData?.displayName}</div>
        <div className="pw-email">{userData.email}</div>
        <div className="pw-phone">
          {userData.dialCode}&nbsp;{userData.mobile}
        </div>
      </div>

      <div className="pw-line" />

      <div className="pw-addressbox w-full">
        <div className="pw-addresstext">{t("Address")}</div>
        {userData?.address && (
          <div className="pw-homewrapper">
            <div className="pw-home">{userData.address.addressType}</div>
            <div className="pw-homeaddressline">
              {userData.address.addressLine1}
            </div>
          </div>
        )}
      </div>

      <div className="pw-line" />

      <SessionsListView
        isDialog={false}
        username={null}
        className="w-full"
      ></SessionsListView>

      {/* <Button className="pw-removebox">
        <div className="pw-delete">
          <DeleteOutlineIcon />
        </div>
        <div className="pw-removeboxtext">Remove account</div>
      </Button> */}
    </div>
  );
};

export default ViewProfile;
